export default class RefundComponent {
  constructor() {
    this.el = $("#refundComponent");

    if (!this.el.length) {
      return false;
    }

    this.preSubmitbutton = this.el.find('.btnPreSubmit');
    this.submitbutton = this.el.find('.btnSubmit');
    this.saveBlock = this.el.find('#save-block');

    this.selectBoxes = this.el.find('.ticketSelect');
    this.selectParents = this.el.find('.selectParent');
    this.btnSetSelects = this.el.find('.btnEventSetSelect');
    this.btnShowTermsModal = this.el.find('#btnShowTermsModal');
    this.btnHideTermsModal = this.el.find('.btnHideTermsModal');
    this.chkApproveTerms = this.el.find('#chkApproveTerms');
    this.termsModal = this.el.find('#terms-modal');

    this.elAlertBox = this.el.find('#alertBox');

    this._btnSetSelectClick = this._btnSetSelectClick.bind(this);
    this._preSubmitClick = this._preSubmitClick.bind(this);
    this._submitClick = this._submitClick.bind(this);
    this._selectBoxChange = this._selectBoxChange.bind(this);
    this._showTermsModal = this._showTermsModal.bind(this);
    this._hideTermsModal = this._hideTermsModal.bind(this);
    this._approveTermsChange = this._approveTermsChange.bind(this);

    this.chkApproveTerms.on('change', this._approveTermsChange);
    this.btnSetSelects.on('click', this._btnSetSelectClick);
    this.preSubmitbutton.on('click', this._preSubmitClick);
    this.submitbutton.on('click', this._submitClick);
    this.selectBoxes.on('change', this._selectBoxChange);


    this._reloadCountdown();
  }

  _reloadCountdown() {
    let timeLeft = 6 * 60;

    var tm = setInterval(() => {
      timeLeft--;

      if (timeLeft <= 4 * 60) {
        let mins = Math.floor(timeLeft / 60);
        let secs = timeLeft - mins * 60;
        if (mins < 10) {
          mins = "0" + mins;
        }
        if (secs < 10) {
          secs = "0" + secs;
        }

        const t = $("#reloadCountdown").data("text").replace("{time}", mins + ":" + secs);
        $("#reloadCountdown").html(t);
      }

      if (timeLeft <= 0 && timeLeft > -5) {
        window.location.href = window.location.href.replace(/#.*$/, '');
        timeLeft = 5;
        clearInterval(tm);
      }
    }, 1000);
  }



  _hideTermsModal() {
    console.log(this.termsModal);
    this.termsModal.hide();
  }
  _showTermsModal() { this.termsModal.show(); }

  _selectBoxChange(e) {
    
    let allPicked = true;
    for (var i = 0; i < this.selectBoxes.length; i++) {
      if (this.selectBoxes[i].value === '') { allPicked = false; }
    }

    if (allPicked) {
      this.elAlertBox.addClass("hide");
      if (this.chkApproveTerms[0].checked) {
        $(this.submitbutton[0]).removeAttr("disabled");
        $(this.preSubmitbutton[0]).removeAttr("disabled");
      } else {
        $(this.submitbutton[0]).attr("disabled", "disabled");
        $(this.preSubmitbutton[0]).attr("disabled", "disabled");
      }
    } else {

      $(this.submitbutton[0]).attr("disabled", "disabled");
      $(this.preSubmitbutton[0]).attr("disabled", "disabled");

      this.elAlertBox.removeClass("hide");
    }
  }



  // BUTTON EVENTS

  _btnSetSelectClick(e) {
    let el = $(e.currentTarget);
    let group = el.attr('data-group');

    let parentSelect = this.selectParents.filter("." + group)[0];
    let value = parentSelect.value;

    let boxes = this.selectBoxes.filter("." + group);
    for (var i = 0; i < boxes.length; i++) {
      boxes[i].value = value;
    }

    this._selectBoxChange();
  }


  _approveTermsChange(e) {
    this._selectBoxChange(e);
  }

  _preSubmitClick(e) {
    let el = $(e.currentTarget)[0];
    if ($(el).attr("disabled") == "disabled" || $(el).hasClass("loading")) { return; }
    this._selectBoxChange();
    this.saveBlock.addClass("save-state");
  }
  _submitClick(e) {

    let el = $(e.currentTarget)[0];
    if ($(el).attr("disabled") == "disabled" || $(el).hasClass("loading")) { return; }
    $(el).addClass("loading");

  }

}